import apiClient from "./apiClient";

/* ===================================================== */
/* Get logged-in user profile                            */
/* GET /user/profile                                     */
/* ===================================================== */

export const getProfile = async () => {
  try {
    const { data } = await apiClient.get("/user/profile");

    if (!data || !data.user) {
      throw new Error("Invalid profile response");
    }

    return {
      user: data.user,
      company: data.company || null,
      membership: data.membership || null,
      effectivePlan: data.effectivePlan || "free",
    };

  } catch (err) {
    throw new Error(err.message || "Failed to fetch user profile");
  }
};

/* ===================================================== */
/* Update user profile                                   */
/* PUT /user/profile                                     */
/* ===================================================== */

export const updateProfile = async (payload) => {
  if (!payload || typeof payload !== "object") {
    throw new Error("Profile update payload is required");
  }

  try {
    const { data } = await apiClient.put("/user/profile", payload);

    if (!data || !data.user) {
      throw new Error("Invalid update response");
    }

    return data.user;

  } catch (err) {
    throw new Error(err.message || "Failed to update profile");
  }
};

/* ===================================================== */
/* USER PERFORMANCE                                      */
/* GET /user/:id/performance                             */
/* ===================================================== */

export const getUserPerformance = async (userId) => {
  if (!userId) {
    throw new Error("User ID is required");
  }

  try {
    const { data } = await apiClient.get(
      `/user/${userId}/performance`
    );

    return {
      assignedTasks: data.assignedTasks || 0,
      completedTasks: data.completedTasks || 0,
      completedOnTime: data.completedOnTime || 0,
      completedLate: data.completedLate || 0,
      overdueTasks: data.overdueTasks || 0,
      activeTasks: data.activeTasks || 0,
      completionRate: data.completionRate || 0,
    };

  } catch (err) {
    throw new Error(
      err?.response?.data?.message ||
      err?.message ||
      "Failed to fetch user performance"
    );
  }
};

/* ===================================================== */
/* Default export                                        */
/* ===================================================== */
const userService = {
  getProfile,
  updateProfile,
  getUserPerformance,
};

export default userService;